import type { RouteLocationNormalized, NavigationGuardNext, Router } from 'vue-router'

function nextFactory(context: { route: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext, router: Router }, middleware: any[], index: number) {
    const subsequentMiddleware = middleware[index];

    if (!subsequentMiddleware) return context.next;

    return (...parameters: Parameters<NavigationGuardNext>) => {

        context.next(...parameters as Parameters<NavigationGuardNext>);

        const nextMiddleware = nextFactory(context, middleware, index + 1);

        subsequentMiddleware({ ...context, next: nextMiddleware });

    };
}


export async function routerMiddleware(route: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext, router: Router) {

    let title = (route.meta.title as string) || "Asl Marka";
    let metaTags = route.meta?.metaTags || [];
    document.title = title;
    (metaTags as any[]).forEach((tag: any) => {
        let meta = document.createElement('meta');
        for (let key in tag) {
            meta.setAttribute(key, tag[key]);
        }
        document.head.appendChild(meta);
    });

    if (route.meta.middleware) {

        const middleware = Array.isArray(route.meta.middleware)
            ? route.meta.middleware
            : [route.meta.middleware];

        const context = { from, next, route, router };

        const nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0]({ ...context, next: nextMiddleware });
    }

    return next();
}
